export default __webpack_public_path__ + "img/eFvpTxUv.38d80247.svg";